module.exports = {
  namespaced: true,

  state: {
    /**
     * Whether menu is visible
     * @type {Boolean}
     */
    isVisible: false
  },

  actions: {
    /**
     * Toggle menu on/off
     */
    toggle ({ commit, state }) {
      commit('SET_IS_VISIBLE', !state.isVisible)
    },

    /**
     * Show the menu
     */
    show ({ commit }) {
      commit('SET_IS_VISIBLE', true)
    },

    /**
     * Hide the menu
     */
    hide ({ commit }) {
      commit('SET_IS_VISIBLE', false)
    }
  },

  mutations: {
    SET_IS_VISIBLE (state, value) {
      state.isVisible = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/menu.js